import {
    ConversationalMMAnalyticsEvent,
    type ConversationalMMAnalyticsEventName,
} from './analytics/events';

export const NO_DATE_HEADLINE = 'Give every paycheck a plan';

export enum MoneyMapStep {
    'Split',
    'System',
    'Timeline',
    'Summary',
}

export const ConversationalMMResultsScreenEvent: Record<
    MoneyMapStep,
    ConversationalMMAnalyticsEventName
> = {
    [MoneyMapStep.Split]: ConversationalMMAnalyticsEvent.ResultsMM,
    [MoneyMapStep.System]: ConversationalMMAnalyticsEvent.ResultsSystem,
    [MoneyMapStep.Timeline]: ConversationalMMAnalyticsEvent.ResultsGraph,
    [MoneyMapStep.Summary]: ConversationalMMAnalyticsEvent.ResultsSummary,
};
